var render, staticRenderFns
import script from "./FormControlMessage.vue?vue&type=script&lang=ts&"
export * from "./FormControlMessage.vue?vue&type=script&lang=ts&"
import style0 from "./FormControlMessage.vue?vue&type=style&index=0&id=5065fd66&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports